/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StaffDashboardPeriodFromJSON, StaffDashboardPeriodToJSON, } from './StaffDashboardPeriod';
import { StaffMediaMetricsFromJSON, StaffMediaMetricsToJSON, } from './StaffMediaMetrics';
import { StaffPlatformMetricsFromJSON, StaffPlatformMetricsToJSON, } from './StaffPlatformMetrics';
/**
 * Check if a given object implements the StaffDashboardSummaryResponse interface.
 */
export function instanceOfStaffDashboardSummaryResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function StaffDashboardSummaryResponseFromJSON(json) {
    return StaffDashboardSummaryResponseFromJSONTyped(json, false);
}
export function StaffDashboardSummaryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'period': !exists(json, 'period') ? undefined : StaffDashboardPeriodFromJSON(json['period']),
        'since': !exists(json, 'since') ? undefined : (new Date(json['since'])),
        'generatedAt': !exists(json, 'generatedAt') ? undefined : (new Date(json['generatedAt'])),
        'platform': !exists(json, 'platform') ? undefined : StaffPlatformMetricsFromJSON(json['platform']),
        'media': !exists(json, 'media') ? undefined : StaffMediaMetricsFromJSON(json['media']),
    };
}
export function StaffDashboardSummaryResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'period': StaffDashboardPeriodToJSON(value.period),
        'since': value.since === undefined ? undefined : (value.since.toISOString()),
        'generatedAt': value.generatedAt === undefined ? undefined : (value.generatedAt.toISOString()),
        'platform': StaffPlatformMetricsToJSON(value.platform),
        'media': StaffMediaMetricsToJSON(value.media),
    };
}
